/* Grand Tea House — theme.js (menu, search, cart count, sliders, quick add) */
(function () {
  'use strict';

  var root = document.documentElement;
  var desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Menu dialog ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-site-menu]');
    if (!menu || typeof menu.showModal !== 'function') return;
    var openers = document.querySelectorAll('[data-menu-open]');
    var lastOpener = null;

    function positionMenu() {
      // Keep the announcement bar visible above the open menu, as in the design.
      var bar = document.querySelector('.announcement-bar');
      var top = bar ? Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) : 0;
      menu.style.setProperty('--menu-top', top + 'px');
    }

    function openMenu(opener) {
      if (menu.open) return;
      lastOpener = opener || null;
      positionMenu();
      menu.showModal();
      root.classList.add('menu-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }

    function closeMenu() {
      if (menu.open) menu.close();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () { openMenu(btn); });
    });
    menu.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });
    menu.addEventListener('close', function () {
      root.classList.remove('menu-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastOpener) lastOpener.focus();
    });
    window.addEventListener('resize', function () { if (menu.open) positionMenu(); });

    /* Accordions (mobile). On desktop every group is shown. */
    var toggles = menu.querySelectorAll('[data-menu-group-toggle]');

    function panelFor(toggle) {
      return document.getElementById(toggle.getAttribute('aria-controls'));
    }
    function setExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var panel = panelFor(toggle);
      if (panel) panel.hidden = !expanded;
    }
    function syncAccordions() {
      toggles.forEach(function (toggle, index) {
        if (desktop.matches) {
          toggle.dataset.mobileState = toggle.getAttribute('aria-expanded');
          setExpanded(toggle, true);
          toggle.disabled = true;
        } else {
          toggle.disabled = false;
          var state = toggle.dataset.mobileState;
          setExpanded(toggle, state ? state === 'true' : index === 0);
        }
      });
    }
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (desktop.matches) return;
        var expanded = toggle.getAttribute('aria-expanded') !== 'true';
        setExpanded(toggle, expanded);
        toggle.dataset.mobileState = String(expanded);
      });
    });
    syncAccordions();
    if (desktop.addEventListener) desktop.addEventListener('change', syncAccordions);
    else if (desktop.addListener) desktop.addListener(syncAccordions);

    return { close: closeMenu };
  }

  /* ---------- Search dialog ---------- */
  function initSearch(menuApi) {
    var dialog = document.querySelector('[data-search-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var input = dialog.querySelector('input[type="search"]');
    var lastOpener = null;

    document.querySelectorAll('[data-search-open]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var insideMenu = !!link.closest('[data-site-menu]');
        if (menuApi) menuApi.close();
        lastOpener = insideMenu ? document.querySelector('.site-header [data-search-open]') : link;
        dialog.showModal();
        if (input) input.focus();
      });
    });
    dialog.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });
    // Click on the backdrop closes the dialog.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      if (lastOpener) lastOpener.focus();
    });
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }
  function refreshCartCount() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }
  // Later stages (product form, cart drawer) dispatch: document.dispatchEvent(new CustomEvent('cart:updated'))
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && typeof event.detail.item_count === 'number') setCartCount(event.detail.item_count);
    else refreshCartCount();
  });
  // Pages restored from the back/forward cache may show a stale count.
  window.addEventListener('pageshow', function (event) { if (event.persisted) refreshCartCount(); });


  /* ---------- Sliders (scroll-snap based) ---------- */
  function initSlider(el) {
    if (el.dataset.sliderReady) return;
    var track = el.querySelector('[data-slider-track]');
    if (!track) return;
    el.dataset.sliderReady = 'true';
    var controls = el.querySelector('[data-slider-controls]');
    var dotsWrap = el.querySelector('[data-slider-dots]');
    var prev = el.querySelector('[data-slider-prev]');
    var next = el.querySelector('[data-slider-next]');
    var count = 0;
    var current = -1;

    function step() {
      var items = track.children;
      if (items.length > 1) {
        var d = items[1].offsetLeft - items[0].offsetLeft;
        if (d > 0) return d;
      }
      return track.clientWidth || 1;
    }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function goTo(index) {
      var left = Math.min(index * step(), maxScroll());
      track.scrollTo({ left: left, behavior: 'smooth' });
    }
    function build() {
      var max = maxScroll();
      var n = max < 8 ? 1 : Math.min(12, Math.ceil((max - 4) / step()) + 1);
      if (n !== count) {
        count = n;
        current = -1;
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'slider-dot';
            b.setAttribute('aria-label', (dotsWrap.dataset.label || 'Go to slide') + ' ' + (i + 1));
            b.addEventListener('click', goTo.bind(null, i));
            dotsWrap.appendChild(b);
          }
        }
      }
      if (controls) controls.hidden = n <= 1;
      update();
    }
    function update() {
      var max = maxScroll();
      var index = max - track.scrollLeft < 4 ? count - 1 : Math.min(count - 1, Math.round(track.scrollLeft / step()));
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = max - track.scrollLeft < 4;
      if (index === current) return;
      current = index;
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(count - 1, current + 1)); });
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(track);
    else window.addEventListener('resize', build);
    build();
  }

  /* Start horizontally-scrolling rows in the middle (category tiles, desktop). */
  function initCenterScroll(el) {
    function center() {
      var max = el.scrollWidth - el.clientWidth;
      if (max > 0) el.scrollLeft = max / 2;
    }
    center();
    window.addEventListener('load', center);
  }

  /* ---------- Quick add to cart (product cards) ---------- */
  function initAjaxCartForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('[data-ajax-cart-form]')) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (button) button.classList.add('is-loading');
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (button) {
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            setTimeout(function () { button.classList.remove('is-added'); }, 1800);
          }
          announce(form.dataset.addedMessage || 'Added to cart');
        })
        .catch(function () {
          // Fall back to a normal form post so Shopify can show the error.
          form.removeAttribute('data-ajax-cart-form');
          form.submit();
        });
    });
  }
  var liveRegion;
  function announce(message) {
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = message; }, 50);
  }

  function initSections(scope) {
    (scope || document).querySelectorAll('[data-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-center-scroll]').forEach(initCenterScroll);
  }

  window.GTH = { setCartCount: setCartCount, refreshCartCount: refreshCartCount };

  function init() {
    var menuApi = initMenu();
    initSearch(menuApi);
    initSections(document);
  }
  initAjaxCartForms();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run after the header section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-site-menu]')) init();
    else initSections(event.target);
  });
  // Theme editor: bring the selected slide into view.
  document.addEventListener('shopify:block:select', function (event) {
    var track = event.target.closest('[data-slider-track]');
    if (track) track.scrollTo({ left: event.target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });
})();
